import { render, staticRenderFns } from "./SelectMarcas.vue?vue&type=template&id=07d2e028"
import script from "./SelectMarcas.vue?vue&type=script&lang=js"
export * from "./SelectMarcas.vue?vue&type=script&lang=js"
import style0 from "./SelectMarcas.vue?vue&type=style&index=0&id=07d2e028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports